import React, { useEffect, useRef, useState } from "react"
import { Dropdown, Overlay } from "react-bootstrap"
import { createPortal } from "react-dom"
import {
  HistoryCanvas,
  attachPlaceholdersAfterLoad,
  FabricObject,
  Rect,
  Circle,
  sanitizeCanvasJson,
} from "../shared-canvas"
import {
  widthIcon,
  heightIcon,
  textUploadIcon,
  imgUploadIcon,
  layerIcon,
  disabledLayerIcon,
  layerSendToBackIcon,
  layerBringToFrontIcon,
  undoIcon,
  disabledUndoIcon,
  redoIcon,
  disabledRedoIcon,
  plusIcon,
  minusIcon,
  textBoldIcon,
  textItalicIcon,
  textUnderlineIcon,
  textAlignLeftIcon,
  textAlignCenterIcon,
  textAlignRightIcon,
  textColor,
  textStrike,
  seperatorIcon,
  rotateSvg,
  duplicateIcon,
  deleteIcon,
  addIcon,
  eyeDropperIcon,
  zoomInIcon,
  zoomOutIcon,
  lockIconOpen,
  lockIconClose,
  circleIcon,
  squareIcon,
  placeholderIcon
} from "../../../../assets/images/canvas"
import { CANVAS_COVER_FACTOR, popularFonts } from "../../../../utils/Constant"
import { useIndexedDB } from "../../../../utils/hooks/useIndexedDB"
import { addImage, addText, handleZoom, loadFont, moveSelectedObject, redo, undo } from "../shared-canvas"
import { CustomColorInput } from "../common/Color"
import CanvasSettings from "../common/CanvasSettings"
import FabricCanvas from "../common/FabricCanvas"

FabricObject.prototype.toObject = (function (originalToObject) {
  return function () {
    // Call the original toObject first
    const obj = originalToObject.call(this);

    // Add common properties for all objects
    Object.assign(obj, {
      lockMovementX: this.lockMovementX,
      lockMovementY: this.lockMovementY,
      selectable: this.selectable,
      hasControls: this.hasControls,
      editable: this.editable,
      disableHistory: this.disableHistory || true,
      connect: this.connect || ""
    });

    // Handle Textbox specific properties
    if (this.type === "textbox") {
      Object.assign(obj, {
        text: this.text || "",
        fontSize: this.fontSize,
        scaleX: this.scaleX || 1,
        scaleY: this.scaleY || 1,
        fontWeight: this.fontWeight || "normal",
        fontStyle: this.fontStyle || "normal",
        underline: this.underline || false,
        fontFamily: this.fontFamily || "Arial",
        linethrough: this.linethrough || false,
        textAlign: this.textAlign || "left"
      });
    }

    // Handle Image specific properties
    if (this.type === "image") {
      Object.assign(obj, {
        width: this.width,
        height: this.height,
        scaleX: this.scaleX || 1,
        scaleY: this.scaleY || 1
      });
    }

    return obj;
  };
})(FabricObject.prototype.toObject);

const PersonalizationCanvas = ({ canvas, setCanvas, screen, updateCanvasDimensions, height, width, setHeight, setWidth }) => {
  const [activeObject, setActiveObject] = useState(null)
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [scaleToFit, setScaleToFit] = useState();
  const [scale, setScale] = useState(100);
  const [tooltipPosition, setTooltipPosition] = useState({
    top: 0,
    left: 0,
    visible: false
  })
  const inputRef = useRef(null)
  const [activeObjectSettings, setActiveObjectSettings] = useState({})
  const [showLayersSettings, setShowLayersSettings] = useState(false)
  const [showPlaceholderSettings, setShowPlaceholderSettings] = useState(false)
  const [canUndo, setCanUndo] = useState(false)
  const [canRedo, setCanRedo] = useState(false)
  const layerIconRef = useRef(null)
  const layerMobileIconRef = useRef(null)
  const placeholderIconRef = useRef(null)
  const [userZoomPercent, setUserZoomPercent] = useState(80);

  const { load, save } = useIndexedDB("canvas", "personlizationTemplate",)

  const getHistoryRedoIcon = () => {
    return canRedo ? redoIcon : disabledRedoIcon
  }
  const getHistoryUndoIcon = () => {
    return canUndo ? undoIcon : disabledUndoIcon
  }

  const addRectanglelaceholder = () => {
    if (canvas?.ref) {
      const rect = new Rect({
        left: 10,
        top: 20,
        width: 150,
        height: 100,
        fill: "transparent",
        stroke: "black",
        strokeWidth: 1,
      });
      rect.scaleToWidth(canvas.canvasWidth / CANVAS_COVER_FACTOR)
      rect.toPlaceholder();
      rect.attachPlaceholder(canvas.ref, { disabled: true }); // Attach placeholder behavior
      canvas.ref.add(rect);
      canvas.ref.renderAll();
    }
  };
  const addCirclePlaceholder = () => {
    if (canvas?.ref) {
      const circle = new Circle({
        left: 10,
        top: 20,
        radius: 60,
        fill: "transparent",
        stroke: "black",
        strokeWidth: 1,

      });
      circle.scaleToWidth(canvas.canvasWidth / CANVAS_COVER_FACTOR)
      canvas.ref.add(circle);
      canvas.ref.renderAll();

      circle.toPlaceholder();
      circle.attachPlaceholder(canvas.ref, { disabled: true });
    }
  };



  useEffect(() => {
    const canvasId = `screen-${screen}`;
    let fabricCanvas;
    let autoSavedJSON;

    if (canvasId) {

      const initCanvas = async () => {
        await load(canvas?.id).then((data) => {
          if (data) {
            autoSavedJSON = data
          } else {
            autoSavedJSON = null
          }
        }).catch((error) => {
          console.error("Error loading canvas data:", error);
          autoSavedJSON = null
        });
        fabricCanvas = new HistoryCanvas(canvasId, {
          width: canvas.canvasWidth || 800,
          height: canvas.canvasHeight || 450,
          // background: canvas.backgroundColor || "#ffffff",
          preserveObjectStacking: true,
          selection: false,
        });
        fabricCanvas.backgroundColor = canvas.backgroundColor;
        fabricCanvas.renderAll();
        if (autoSavedJSON) {
          fabricCanvas.loadFromJSON(sanitizeCanvasJson(autoSavedJSON)).then(() => {
            attachPlaceholdersAfterLoad(fabricCanvas, { disabled: true });
            if (autoSavedJSON.background) {
              canvas.backgroundColor = autoSavedJSON.background;
              fabricCanvas.backgroundColor = autoSavedJSON.background;
              fabricCanvas.renderAll();
            }
          });
        }
        else if (canvas.ref) {
          const canvasJSON = canvas.ref.toJSON();
          fabricCanvas.loadFromJSON(sanitizeCanvasJson(canvasJSON)).then(() => {
            attachPlaceholdersAfterLoad(fabricCanvas, { disabled: true });
          });
        }
        else if (Array.isArray(canvas.layers) && canvas.layers.length > 0) {

          const jsonData = {
            version: "6.9.1",
            objects: [...canvas.layers],
            background: canvas.backgroundColor || "#ffffff",
          };
          fabricCanvas.loadFromJSON(sanitizeCanvasJson(jsonData)).then(() => {
            attachPlaceholdersAfterLoad(fabricCanvas, { disabled: true });
          });
        }

        setCanvas({
          ...canvas,
          ref: fabricCanvas,
        })

        return fabricCanvas;
      };

      void initCanvas();
    }

  }, []);


  useEffect(() => {
    if (!canvas.ref) {
      return
    };

    const handleObjectChange = () => {
      save(canvas?.id, canvas.ref.toJSON())
    }
    const handleObjectMovingOrScaling = () => {
      save(canvas?.id, canvas.ref.toJSON())
    }

    canvas.ref.on("canvas:background:changed", handleObjectChange)

    canvas.ref.on("object:moving", handleObjectMovingOrScaling)
    canvas.ref.on("object:scaling", handleObjectMovingOrScaling)
    canvas.ref.on("object:modified", handleObjectMovingOrScaling)
    canvas.ref.on("object:added", handleObjectChange)
    canvas.ref.on("object:modified", handleObjectChange)
    canvas.ref.on("object:removed", handleObjectChange)

    return () => {
      canvas.ref.off("object:added", handleObjectChange)
      canvas.ref.off("object:modified", handleObjectChange)
      canvas.ref.off("object:removed", handleObjectChange)
      canvas.ref.off("object:moving", handleObjectMovingOrScaling)
      canvas.ref.off("object:scaling", handleObjectMovingOrScaling)
      canvas.ref.off("object:modified", handleObjectMovingOrScaling)
      canvas.ref.off("canvas:background:changed", handleObjectChange)
    }
  }, [canvas.ref])


  return (
    <>
      <CanvasSettings
        canvas={canvas}
        activeObject={{ setActiveObject, setActiveObjectSettings }}
        actions={{ setCanRedo, setCanUndo }}
        scaleSettings={{ setScale, setScaleToFit, setUserZoomPercent, scale, scaleToFit, position, setPosition }}
      />
      <div className="cobrand-canvas-container">
        <div className="main-container">
          <div className="d-flex justify-content-between my-3 align-items-end">
            <div>
              {!activeObject ? (

                <div className="canvas-dimensions">
                  <p>Background:</p>
                  <div className="d-flex align-items-center">
                    <img src={widthIcon} className="mx-2" alt="Width Icon" />
                    <span>Width:</span>
                    <div className="canvas-size-main ml-2">
                      <input
                        type="number"
                        id="canvas-size-input"
                        value={width}
                        onChange={(e) => {
                          const newWidth = e.target.value === "" ? "" : Number(e.target.value);
                          updateCanvasDimensions(newWidth, height);
                        }}
                        onBlur={() => {
                          if (width === "") setWidth(500);
                        }}
                      />
                      <img
                        src={minusIcon}
                        onClick={() => updateCanvasDimensions(width - 10, height)}
                        className="before"
                        alt="Decrease Width"
                      />
                      <img
                        src={plusIcon}
                        onClick={() => updateCanvasDimensions(width + 10, height)}
                        className="after"
                        alt="Increase Width"
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center mt-1">
                    <img src={heightIcon} className="mx-2" alt="Height Icon" />
                    <span>Height:</span>
                    <div className="canvas-size-main ml-2">
                      <input
                        type="number"
                        id="canvas-size-input"
                        value={height}
                        onChange={(e) => {
                          const newHeight = e.target.value === "" ? "" : Number(e.target.value);
                          updateCanvasDimensions(width, newHeight);
                        }}
                        onBlur={() => {
                          if (height === "") setHeight(300);
                        }}
                      />
                      <img
                        src={minusIcon}
                        onClick={() => updateCanvasDimensions(width, height - 10)}
                        className="before"
                        alt="Decrease Height"
                      />
                      <img
                        src={plusIcon}
                        onClick={() => updateCanvasDimensions(width, height + 10)}
                        className="after"
                        alt="Increase Height"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {activeObject && activeObject.type === "textbox" && (
                    <div className="canvas-dimensions">
                      <p>Text:</p>
                      <p className="d-flex align-items-center ">
                        <img src={widthIcon} className="mx-2" alt="" />
                        Width:{" "}
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            step={1}
                            value={(activeObject.width * activeObject.scaleX).toFixed(0)} // Show actual width
                            onChange={(e) => {
                              const newWidth = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Calculate new scale
                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                          />

                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) - 10; // Decrease width
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Width"
                          />

                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) + 10; // Increase width
                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Width"
                          />
                        </div>
                      </p>
                      <p className="d-flex align-items-center ">
                        <img src={heightIcon} className="mx-2" alt="" />
                        Height:{" "}
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            value={(activeObject.height * activeObject.scaleY).toFixed(0)}
                            onChange={(e) => {
                              const newHeight = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                          />
                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) - 10; // Decrease height
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Height"
                          />
                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) + 10; // Increase height
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Height"
                          />

                        </div>
                      </p>
                    </div>
                  )}
                  {activeObject && activeObject.type === "image" && (
                    <div className="canvas-dimensions">
                      <p>Image:</p>
                      <p className="d-flex align-items-center ">
                        <img src={widthIcon} className="mx-2" alt="" />
                        Width:
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            step={1}
                            value={(activeObject.width * activeObject.scaleX).toFixed(0)} // Show actual width
                            onChange={(e) => {
                              const newWidth = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Calculate new scale
                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                          />

                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) - 10; // Decrease width
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Width"
                          />

                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) + 10; // Increase width
                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Width"
                          />
                        </div>
                      </p>
                      <p className="d-flex align-items-center ">
                        <img src={heightIcon} className="mx-2" alt="" />
                        Height:
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            value={(activeObject.height * activeObject.scaleY).toFixed(0)}
                            onChange={(e) => {
                              const newHeight = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                          />
                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) - 10; // Decrease height
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Height"
                          />
                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) + 10; // Increase height
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Height"
                          />

                        </div>
                      </p>
                    </div>
                  )}
                  {activeObject && (activeObject.type === "rect" || activeObject.type === "circle") && (
                    <div className="canvas-dimensions">
                      <p>Placeholder:</p>
                      <p className="d-flex align-items-center ">
                        <img src={widthIcon} className="mx-2" alt="" />
                        Width:
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            step={1}
                            value={(activeObject.width * activeObject.scaleX).toFixed(0)} // Show actual width
                            onChange={(e) => {
                              const newWidth = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Calculate new scale
                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                          />

                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) - 10; // Decrease width
                              if (newWidth <= 0) return;

                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Width"
                          />

                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newWidth = (activeObject.width * activeObject.scaleX) + 10; // Increase width
                              const newScaleX = newWidth / activeObject.width; // Compute new scaleX

                              setActiveObjectSettings({ ...activeObjectSettings, scaleX: newScaleX });

                              activeObject.set({
                                scaleX: newScaleX,
                              });

                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Width"
                          />
                        </div>
                      </p>
                      <p className="d-flex align-items-center ">
                        <img src={heightIcon} className="mx-2" alt="" />
                        Height:
                        <div className="canvas-size-main ml-2">
                          <input
                            type="number"
                            id="canvas-size-input"
                            value={(activeObject.height * activeObject.scaleY).toFixed(0)}
                            onChange={(e) => {
                              const newHeight = e.target.value === "" ? "" : Number(e.target.value).toFixed(0);
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                          />
                          <img
                            src={minusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) - 10; // Decrease height
                              if (newHeight <= 0) return;
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="before"
                            alt="Decrease Height"
                          />
                          <img
                            src={plusIcon}
                            onClick={() => {
                              const newHeight = (activeObject.height * activeObject.scaleY) + 10; // Increase height
                              const newScaleY = newHeight / activeObject.height;
                              setActiveObjectSettings({ ...activeObjectSettings, scaleY: newScaleY });
                              activeObject.set({
                                scaleY: newScaleY,
                              });
                              canvas?.ref?.renderAll();
                            }}
                            className="after"
                            alt="Increase Height"
                          />

                        </div>
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
            <div>
              <div className="canvas-zoom">
                <img
                  src={zoomOutIcon}
                  alt="Zoom Out"
                  onClick={() => handleZoom("out", { scaleToFit, setUserZoomPercent, setScale })}
                />
                {userZoomPercent + 20}%
                <img
                  src={zoomInIcon}
                  alt="Zoom In"
                  onClick={() => handleZoom("in", { scaleToFit, setUserZoomPercent, setScale })}
                />
              </div>
            </div>
          </div>
          <div className="playground-wrapper">
            <div className="playground" onClick={(e) => {

              if (canvas?.ref) {
                const target = canvas.ref.findTarget(e.nativeEvent, false);
                if (!target) {
                  canvas.ref.discardActiveObject();
                  canvas.ref.renderAll();
                  setActiveObject(null);
                }
              }
            }}>
              <FabricCanvas id={`screen-${screen}`} />
            </div>

          </div>
        </div>

        <div className="canvas-sidebar">
          <p title="Upload Image">
            <img
              src={imgUploadIcon}
              alt=""
              onClick={() => inputRef?.current?.click()}
            />
            <input
              type="file"
              className="d-none"
              accept="image/*"
              onChange={(e) => addImage(e, canvas)}
              ref={inputRef}
            />
          </p>
          <p title="Add Placeholder" ref={placeholderIconRef}>
            <img
              src={placeholderIcon}
              alt=""
              onClick={() => setShowPlaceholderSettings(true)}
            />
            {placeholderIconRef.current && (
              <Overlay
                show={showPlaceholderSettings}
                onHide={() => setShowPlaceholderSettings(false)}
                rootClose={true}
                target={placeholderIconRef.current}
                placement="right"
              >
                <div className="layers-open">
                  <p onClick={() => addRectanglelaceholder()} title="Rectangle Placeholder">
                    <img src={squareIcon} alt="" />
                  </p>
                  <p onClick={() => addCirclePlaceholder()} title="Circle Placeholder">
                    <img src={circleIcon} alt="" />
                  </p>
                </div>
              </Overlay>
            )}
          </p>
          <p onClick={() => addText(canvas)} title="Add Text">
            <img src={textUploadIcon} alt="" />
          </p>

          <p ref={layerIconRef} title="Layer">
            <img
              src={activeObject ? layerIcon : disabledLayerIcon}
              alt=""
              onClick={() => {
                if (activeObject) setShowLayersSettings(true)
              }}
            />
            {layerIconRef.current && (
              <Overlay
                show={showLayersSettings}
                onHide={() => setShowLayersSettings(false)}
                rootClose={true}
                target={layerIconRef.current}
                placement="right"
              >
                <div className="layers-open">
                  <p onClick={() => moveSelectedObject("up", canvas, setActiveObject)} title="Bring to Front">
                    <img src={layerBringToFrontIcon} alt="" />
                  </p>
                  <p onClick={() => moveSelectedObject("down", canvas, setActiveObject)} title="Send to Back">
                    <img src={layerSendToBackIcon} alt="" />
                  </p>
                </div>
              </Overlay>
            )}
          </p>
          <p onClick={() => undo(canvas)} title="Undo">
            <img src={getHistoryUndoIcon()} alt="" />
          </p>
          <p onClick={() => redo(canvas)} title="Redo">
            <img src={getHistoryRedoIcon()} alt="" />
          </p>
          {activeObject?.hasControls ? (
            <>
              {/* Duplicate Icon */}
              {(activeObject?.type !== "rect" && activeObject?.type !== "circle") &&

                <img
                  src={duplicateIcon}
                  alt="Duplicate"
                  title="Duplicate"
                  onClick={() => {
                    if (!activeObject) return;

                    activeObject.clone().then((clonedObject) => {
                      if (clonedObject) {
                        clonedObject.set({
                          left: activeObject.left + 20,
                          top: activeObject.top + 20,
                          evented: true,
                          editable: true
                        });

                        canvas.ref.add(clonedObject);
                        canvas.ref.setActiveObject(clonedObject);
                        canvas.ref.renderAll();
                      }
                    });
                  }}
                />
              }

              {/* Delete Icon */}
              <img
                src={deleteIcon}
                title="Delete"
                alt="Delete"
                onClick={() => {
                  canvas.ref.remove(activeObject);
                  canvas.ref.renderAll();
                }}
              />

              {/* Lock Icon (Open) */}
              <img
                src={lockIconOpen}
                alt="Lock"
                title="Lock"
                onClick={() => {
                  const activeObject = canvas?.ref?.getActiveObject();

                  if (activeObject) {
                    // Lock the object (but keep it selectable)
                    activeObject.set("editable", false);
                    activeObject.set({
                      lockMovementX: true,
                      lockMovementY: true,
                      selectable: true,
                      hasControls: false,
                    });

                    // Hide tooltip after locking
                    setTooltipPosition((prev) => ({ ...prev, visible: false }));
                    canvas.ref.renderAll();
                  }
                }}
              />
            </>
          ) : (
            activeObject && (
              <>
                {/* Lock Icon (Close) */}
                <img
                  src={lockIconClose}
                  alt="Unlock"
                  title="Unlock"
                  onClick={() => {
                    const activeObject = canvas?.ref?.getActiveObject();

                    if (activeObject) {
                      // Unlock the object
                      activeObject.set("editable", true);
                      activeObject.set({
                        lockMovementX: false,
                        lockMovementY: false,
                        selectable: true,
                        hasControls: true,
                      });

                      // Hide tooltip after unlocking
                      setTooltipPosition((prev) => ({ ...prev, visible: false }));
                      canvas.ref.renderAll();
                    }
                  }}
                />
              </>
            )
          )}

        </div>
        <div className="canvas-bottombar">
          {!activeObject && (
            <div className="main d-flex gap-8">
              <CustomColorInput
                onChange={(e) =>
                  setCanvas({
                    ...canvas,
                    backgroundColor: e.target.value
                  })
                }
                value={canvas.backgroundColor}
              />
              <img src={seperatorIcon} className="show-mobile" alt="" />
              <div className="canvas-sidebar show-mobile gap-8">
                <p title="Upload Image">
                  <img
                    src={imgUploadIcon}
                    alt=""
                    onClick={() => inputRef?.current?.click()}
                  />
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    onChange={(e) => addImage(e, canvas)}
                    ref={inputRef}
                  />
                </p>
                <p onClick={() => addText(canvas)} title="Add Text">
                  <img src={textUploadIcon} alt="" />
                </p>

                <p ref={layerMobileIconRef} title="Layer">
                  <img
                    src={activeObject ? layerIcon : disabledLayerIcon}
                    alt=""
                    onClick={() => {
                      if (activeObject) setShowLayersSettings(true)
                    }}
                  />
                  {layerMobileIconRef.current && (
                    <Overlay
                      show={showLayersSettings}
                      onHide={() => setShowLayersSettings(false)}
                      rootClose={true}
                      target={layerMobileIconRef.current}
                      placement="top"
                    >
                      <div className="layers-open">
                        <p onClick={() => moveSelectedObject("up", canvas, setActiveObject)} title="Bring to Front">
                          <img src={layerBringToFrontIcon} alt="" />
                        </p>
                        <p onClick={() => moveSelectedObject("down", canvas, setActiveObject)} title="Send to Back">
                          <img src={layerSendToBackIcon} alt="" />
                        </p>
                      </div>
                    </Overlay>
                  )}
                </p>
                <p onClick={() => undo(canvas)} title="Undo">
                  <img src={getHistoryUndoIcon()} alt="" />
                </p>
                <p onClick={() => redo(canvas)} title="Redo">
                  <img src={getHistoryRedoIcon()} alt="" />
                </p>
                {activeObject?.hasControls ? (
                  <>
                    {/* Duplicate Icon */}
                    {(activeObject?.type !== "rect" && activeObject?.type !== "circle") &&

                      <img
                        src={duplicateIcon}
                        alt="Duplicate"
                        title="Duplicate"
                        onClick={() => {
                          if (!activeObject) return;

                          activeObject.clone().then((clonedObject) => {
                            if (clonedObject) {
                              clonedObject.set({
                                left: activeObject.left + 20,
                                top: activeObject.top + 20,
                                evented: true,
                                editable: true
                              });

                              canvas.ref.add(clonedObject);
                              canvas.ref.setActiveObject(clonedObject);
                              canvas.ref.renderAll();
                            }
                          });
                        }}
                      />
                    }

                    {/* Delete Icon */}
                    <img
                      src={deleteIcon}
                      title="Delete"
                      alt="Delete"
                      onClick={() => {
                        canvas.ref.remove(activeObject);
                        canvas.ref.renderAll();
                      }}
                    />

                    {/* Lock Icon (Open) */}
                    <img
                      src={lockIconOpen}
                      alt="Lock"
                      title="Lock"
                      onClick={() => {
                        const activeObject = canvas?.ref?.getActiveObject();

                        if (activeObject) {
                          // Lock the object (but keep it selectable)
                          activeObject.set("editable", false);
                          activeObject.set({
                            lockMovementX: true,
                            lockMovementY: true,
                            selectable: true,
                            hasControls: false,
                          });

                          // Hide tooltip after locking
                          setTooltipPosition((prev) => ({ ...prev, visible: false }));
                          canvas.ref.renderAll();
                        }
                      }}
                    />
                  </>
                ) : (
                  activeObject && (
                    <>
                      {/* Lock Icon (Close) */}
                      <img
                        src={lockIconClose}
                        alt="Unlock"
                        title="Unlock"
                        onClick={() => {
                          const activeObject = canvas?.ref?.getActiveObject();

                          if (activeObject) {
                            // Unlock the object
                            activeObject.set("editable", true);
                            activeObject.set({
                              lockMovementX: false,
                              lockMovementY: false,
                              selectable: true,
                              hasControls: true,
                            });

                            // Hide tooltip after unlocking
                            setTooltipPosition((prev) => ({ ...prev, visible: false }));
                            canvas.ref.renderAll();
                          }
                        }}
                      />
                    </>
                  )
                )}
              </div>
            </div>
          )}
          {activeObject && activeObject.type === "textbox" && activeObject?.editable && (
            <div className="main">
              <div className="d-flex align-items-center gap-8">
                <div className="show-desktop">
                  <CustomColorInput
                    onChange={(e) =>
                      setCanvas({
                        ...canvas,
                        backgroundColor: e.target.value
                      })
                    }
                    value={canvas.backgroundColor}
                  />
                </div>
                <div className="canvas-sidebar show-mobile gap-8">
                  <p ref={layerMobileIconRef} title="Layer">
                    <img
                      src={activeObject ? layerIcon : disabledLayerIcon}
                      alt=""
                      onClick={() => {
                        if (activeObject) setShowLayersSettings(true)
                      }}
                    />
                    {layerMobileIconRef.current && (
                      <Overlay
                        show={showLayersSettings}
                        onHide={() => setShowLayersSettings(false)}
                        rootClose={true}
                        target={layerMobileIconRef.current}
                        placement="top"
                      >
                        <div className="layers-open">
                          <p onClick={() => moveSelectedObject("up", canvas, setActiveObject)} title="Bring to Front">
                            <img src={layerBringToFrontIcon} alt="" />
                          </p>
                          <p onClick={() => moveSelectedObject("down", canvas, setActiveObject)} title="Send to Back">
                            <img src={layerSendToBackIcon} alt="" />
                          </p>
                        </div>
                      </Overlay>
                    )}
                  </p>
                  <p onClick={() => undo(canvas)} title="Undo">
                    <img src={getHistoryUndoIcon()} alt="" />
                  </p>
                  <p onClick={() => redo(canvas)} title="Redo">
                    <img src={getHistoryRedoIcon()} alt="" />
                  </p>
                  {activeObject?.hasControls ? (
                    <>
                      {/* Duplicate Icon */}
                      {(activeObject?.type !== "rect" && activeObject?.type !== "circle") &&

                        <img
                          src={duplicateIcon}
                          alt="Duplicate"
                          title="Duplicate"
                          onClick={() => {
                            if (!activeObject) return;

                            activeObject.clone().then((clonedObject) => {
                              if (clonedObject) {
                                clonedObject.set({
                                  left: activeObject.left + 20,
                                  top: activeObject.top + 20,
                                  evented: true,
                                  editable: true
                                });

                                canvas.ref.add(clonedObject);
                                canvas.ref.setActiveObject(clonedObject);
                                canvas.ref.renderAll();
                              }
                            });
                          }}
                        />
                      }

                      {/* Delete Icon */}
                      <img
                        src={deleteIcon}
                        title="Delete"
                        alt="Delete"
                        onClick={() => {
                          canvas.ref.remove(activeObject);
                          canvas.ref.renderAll();
                        }}
                      />

                      {/* Lock Icon (Open) */}
                      <img
                        src={lockIconOpen}
                        alt="Lock"
                        title="Lock"
                        onClick={() => {
                          const activeObject = canvas?.ref?.getActiveObject();

                          if (activeObject) {
                            // Lock the object (but keep it selectable)
                            activeObject.set("editable", false);
                            activeObject.set({
                              lockMovementX: true,
                              lockMovementY: true,
                              selectable: true,
                              hasControls: false,
                            });

                            // Hide tooltip after locking
                            setTooltipPosition((prev) => ({ ...prev, visible: false }));
                            canvas.ref.renderAll();
                          }
                        }}
                      />
                    </>
                  ) : (
                    activeObject && (
                      <>
                        {/* Lock Icon (Close) */}
                        <img
                          src={lockIconClose}
                          alt="Unlock"
                          title="Unlock"
                          onClick={() => {
                            const activeObject = canvas?.ref?.getActiveObject();

                            if (activeObject) {
                              // Unlock the object
                              activeObject.set("editable", true);
                              activeObject.set({
                                lockMovementX: false,
                                lockMovementY: false,
                                selectable: true,
                                hasControls: true,
                              });

                              // Hide tooltip after unlocking
                              setTooltipPosition((prev) => ({ ...prev, visible: false }));
                              canvas.ref.renderAll();
                            }
                          }}
                        />
                      </>
                    )
                  )}
                </div>
                <p>
                  <img src={seperatorIcon} />
                </p>
                <p>
                  <Dropdown drop="up">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {activeObjectSettings?.fontFamily}
                    </Dropdown.Toggle>

                    {createPortal(
                      <Dropdown.Menu
                        style={{ position: "absolute", zIndex: 1050 }}
                      >
                        {popularFonts.map((font) => (
                          <Dropdown.Item
                            key={font}
                            onClick={async () => {
                              setActiveObjectSettings((p) => ({
                                ...p,
                                fontFamily: font
                              }))
                              await loadFont(font)
                              activeObject.set({ fontFamily: font })
                              canvas?.ref?.renderAll()
                            }}
                          >
                            {font}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>,
                      document.body // Render to the body
                    )}
                  </Dropdown>
                </p>
                <p className="font-size-main">
                  <input
                    type="number"
                    id="font-size-input"
                    value={activeObjectSettings?.fontSize || 16} // Default to 16 if fontSize is undefined
                    onChange={(e) => {
                      if (!activeObject?.editable) return;
                      const newFontSize = Number(e.target.value)

                      if (newFontSize > 0) {
                        setActiveObjectSettings((prevSettings) => ({
                          ...prevSettings,
                          fontSize: newFontSize
                        }))
                        if (activeObject) {
                          activeObject.set({ fontSize: newFontSize })
                          canvas?.ref?.renderAll() // Re-render the canvas
                        }
                      }
                    }}
                  />
                  <img
                    src={minusIcon}
                    onClick={() => {
                      if (!activeObject) return;
                      const newFontSize = activeObjectSettings.fontSize - 1
                      if (newFontSize > 0) {
                        setActiveObjectSettings((prevSettings) => ({
                          ...prevSettings,
                          fontSize: newFontSize
                        }))
                        activeObject.set({ fontSize: newFontSize })

                        canvas?.ref?.renderAll()
                      }
                    }}
                    className="before"
                    alt=""
                  />
                  <img
                    src={plusIcon}
                    onClick={() => {
                      if (!activeObject?.editable) return;
                      const newFontSize = activeObjectSettings.fontSize + 1
                      setActiveObjectSettings((prevSettings) => ({
                        ...prevSettings,
                        fontSize: newFontSize
                      }))
                      activeObject.set({ fontSize: newFontSize })

                      canvas?.ref?.renderAll()
                    }}
                    className="after"
                    alt=""
                  />
                </p>

                <p>
                  <CustomColorInput
                    value={activeObjectSettings.fill}
                    onChange={(e) => {
                      const newColor = e.target.value
                      setActiveObjectSettings((prevSettings) => ({
                        ...prevSettings,
                        fill: newColor
                      }))
                      activeObject.set({ fill: newColor })
                      canvas?.ref?.renderAll()
                    }}
                  >
                    <img src={textColor} alt="" />
                  </CustomColorInput>
                </p>
                <p
                  className={
                    activeObjectSettings.fontWeight === "bold" ? "active" : ""
                  }
                  title="Bold"
                  onClick={() => {
                    if (!activeObject?.editable) return;
                    const newWetight =
                      activeObject.fontWeight === "bold" ? "normal" : "bold"
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      fontWeight: newWetight
                    }))
                    activeObject.set({ fontWeight: newWetight })
                    canvas?.ref?.renderAll()
                  }}
                >
                  <img src={textBoldIcon} alt="" />
                </p>
                <p
                  className={
                    activeObjectSettings.fontStyle === "italic"
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    if (!activeObject?.editable) return;
                    const newStyle =
                      activeObject.fontStyle === "italic"
                        ? "normal"
                        : "italic"
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      fontStyle: newStyle
                    }))
                    activeObject.set({ fontStyle: newStyle })
                    canvas?.ref?.renderAll()
                  }}
                  title="Italic"
                >
                  <img src={textItalicIcon} alt="" />
                </p>
                <p
                  className={activeObjectSettings.underline ? "active" : ""}
                  onClick={() => {
                    if (!activeObject?.editable) return;
                    const newUnderline = !activeObject.underline
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      underline: newUnderline
                    }))
                    activeObject.set({ underline: newUnderline })
                    canvas?.ref?.renderAll()
                  }}
                  title="Underline"
                >
                  <img src={textUnderlineIcon} alt="" />
                </p>
                <p
                  className={activeObjectSettings.linethrough ? "active" : ""}
                  onClick={() => {
                    if (!activeObject?.editable) return;
                    const newlinethrough = !activeObject.linethrough
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      linethrough: newlinethrough
                    }))
                    activeObject.set({ linethrough: newlinethrough })
                    canvas?.ref?.renderAll()
                  }}
                >
                  <img src={textStrike} alt="" />
                </p>
                <img src={seperatorIcon} alt="" />
                <p
                  className={
                    activeObjectSettings.textAlign === "left" ? "active" : ""
                  }
                  onClick={() => {
                    if (!activeObject?.editable) return;
                    activeObject.set({ textAlign: "left" })
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      textAlign: "left"
                    }))
                    canvas?.ref?.renderAll()
                  }}
                  title="Align Left"
                >
                  <img src={textAlignLeftIcon} alt="" />
                </p>
                <p
                  className={
                    activeObjectSettings.textAlign === "center"
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    activeObject.set({ textAlign: "center" })
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      textAlign: "center"
                    }))
                    canvas?.ref?.renderAll()
                  }}
                  title="Align Center"
                >
                  <img src={textAlignCenterIcon} alt="" />
                </p>
                <p
                  className={
                    activeObjectSettings.textAlign === "right" ? "active" : ""
                  }
                  onClick={() => {
                    if (!activeObject?.editable) return;

                    if (!activeObject?.editable) return;
                    activeObject.set({ textAlign: "right" })
                    setActiveObjectSettings((prevSettings) => ({
                      ...prevSettings,
                      textAlign: "right"
                    }))
                    canvas?.ref?.renderAll()
                  }}
                  title="Align Right"
                >
                  <img src={textAlignRightIcon} alt="" />
                </p>
              </div>
            </div>
          )}
          {activeObject && activeObject.type === "image" && (
            <div className="main">
              <div className="d-flex align-items-center gap-8">
                <div className="">
                  <CustomColorInput
                    onChange={(e) =>
                      setCanvas({
                        ...canvas,
                        backgroundColor: e.target.value
                      })
                    }
                    value={canvas.backgroundColor}
                  />
                </div>{" "}
                <p className="show-mobile">
                  <img src={seperatorIcon} />
                </p>
                <div className="canvas-sidebar show-mobile gap-8" title="Layer">
                  <p ref={layerMobileIconRef}>
                    <img
                      src={activeObject ? layerIcon : disabledLayerIcon}
                      alt=""
                      onClick={() => {
                        if (activeObject) setShowLayersSettings(true)
                      }}
                    />
                    {layerMobileIconRef.current && (
                      <Overlay
                        show={showLayersSettings}
                        onHide={() => setShowLayersSettings(false)}
                        rootClose={true}
                        target={layerMobileIconRef.current}
                        placement="top"
                      >
                        <div className="layers-open">
                          <p onClick={() => moveSelectedObject("up", canvas, setActiveObject)} title="Bring to Front">
                            <img src={layerBringToFrontIcon} alt="" />
                          </p>
                          <p onClick={() => moveSelectedObject("down", canvas, setActiveObject)} title="Send to Back">
                            <img src={layerSendToBackIcon} alt="" />
                          </p>
                        </div>
                      </Overlay>
                    )}
                  </p>
                  <p onClick={() => undo(canvas)} title="Undo">
                    <img src={getHistoryUndoIcon()} alt="" />
                  </p>
                  <p onClick={() => redo(canvas)} title="Redo">
                    <img src={getHistoryRedoIcon()} alt="" />
                  </p>
                  {activeObject?.hasControls ? (
                    <>
                      {/* Duplicate Icon */}
                      {(activeObject?.type !== "rect" && activeObject?.type !== "circle") &&

                        <img
                          src={duplicateIcon}
                          alt="Duplicate"
                          title="Duplicate"
                          onClick={() => {
                            if (!activeObject) return;

                            activeObject.clone().then((clonedObject) => {
                              if (clonedObject) {
                                clonedObject.set({
                                  left: activeObject.left + 20,
                                  top: activeObject.top + 20,
                                  evented: true,
                                  editable: true
                                });

                                canvas.ref.add(clonedObject);
                                canvas.ref.setActiveObject(clonedObject);
                                canvas.ref.renderAll();
                              }
                            });
                          }}
                        />
                      }

                      {/* Delete Icon */}
                      <img
                        src={deleteIcon}
                        title="Delete"
                        alt="Delete"
                        onClick={() => {
                          canvas.ref.remove(activeObject);
                          canvas.ref.renderAll();
                        }}
                      />

                      {/* Lock Icon (Open) */}
                      <img
                        src={lockIconOpen}
                        alt="Lock"
                        title="Lock"
                        onClick={() => {
                          const activeObject = canvas?.ref?.getActiveObject();

                          if (activeObject) {
                            // Lock the object (but keep it selectable)
                            activeObject.set("editable", false);
                            activeObject.set({
                              lockMovementX: true,
                              lockMovementY: true,
                              selectable: true,
                              hasControls: false,
                            });

                            // Hide tooltip after locking
                            setTooltipPosition((prev) => ({ ...prev, visible: false }));
                            canvas.ref.renderAll();
                          }
                        }}
                      />
                    </>
                  ) : (
                    activeObject && (
                      <>
                        {/* Lock Icon (Close) */}
                        <img
                          src={lockIconClose}
                          alt="Unlock"
                          title="Unlock"
                          onClick={() => {
                            const activeObject = canvas?.ref?.getActiveObject();

                            if (activeObject) {
                              // Unlock the object
                              activeObject.set("editable", true);
                              activeObject.set({
                                lockMovementX: false,
                                lockMovementY: false,
                                selectable: true,
                                hasControls: true,
                              });

                              // Hide tooltip after unlocking
                              setTooltipPosition((prev) => ({ ...prev, visible: false }));
                              canvas.ref.renderAll();
                            }
                          }}
                        />
                      </>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </>
  )
}


export default PersonalizationCanvas
